import FallbackLoader from './FallbackLoader';

export default FallbackLoader(() => import(/* webpackChunkName: "async-ContentSelectPoi" */'@modals/partials/ContentSelectPoi'));
